class StoreActionHelper {
  #storeName = '';

  constructor(storeName) {
    this.#storeName = storeName;
  }

  getAction(type) {
    return `${this.#storeName}/${type}`;
  }
}

export default StoreActionHelper;
